import axios from 'axios';

const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

let cache = {
  tokenSignature: null,
  organizationId: null,
  data: null,
  timestamp: 0,
  inFlight: null,
};

const getTokenSignature = (token) => {
  if (!token) return null;
  // Avoid storing full token; use length + last 8 chars as a lightweight signature
  return `${token.length}:${token.slice(-8)}`;
};

const getOrganizationId = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user.activeOrganizationId || user.companyId || null;
  } catch (error) {
    return null;
  }
};

const fetchFromApi = async (token) => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}/brand/assets`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

const resolveToken = (overrideToken) => {
  if (overrideToken) return overrideToken;
  if (typeof window === 'undefined') return null;
  return localStorage.getItem('token');
};

export const getBrandAssetsCached = async ({ force = false, token: overrideToken } = {}) => {
  const token = resolveToken(overrideToken);
  if (!token) {
    return {
      brandAssets: null,
      sidebarLogoPreference: 'brandmark',
      source: 'none',
    };
  }

  const tokenSignature = getTokenSignature(token);
  const organizationId = getOrganizationId();
  const now = Date.now();

  // Cache hit only if token AND organization match
  const cacheHit =
    !force &&
    cache.data &&
    cache.tokenSignature === tokenSignature &&
    cache.organizationId === organizationId &&
    now - cache.timestamp < CACHE_TTL_MS;

  if (cacheHit) {
    return cache.data;
  }

  // In-flight check should also match organization
  if (!force && cache.inFlight && cache.tokenSignature === tokenSignature && cache.organizationId === organizationId) {
    return cache.inFlight;
  }

  const requestPromise = fetchFromApi(token)
    .then((data) => {
      cache = {
        tokenSignature,
        organizationId,
        data,
        timestamp: Date.now(),
        inFlight: null,
      };
      return data;
    })
    .catch((error) => {
      cache.inFlight = null;
      throw error;
    });

  cache = {
    ...cache,
    tokenSignature,
    organizationId,
    inFlight: requestPromise,
  };

  return requestPromise;
};

export const forceRefreshBrandAssets = async (options = {}) =>
  getBrandAssetsCached({ ...options, force: true });

export const clearBrandAssetsCache = () => {
  cache = {
    tokenSignature: null,
    organizationId: null,
    data: null,
    timestamp: 0,
    inFlight: null,
  };
};








